import { Box, Grid, Typography } from "@mui/material";
import { FormNumberField } from "@zfp-akademie-a-s/zfp-design/form/number-field";
import { CurrencyCode } from "Infrastructure/Models/CurrencyCodes";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { formatCurrency } from "Infrastructure/Utils/CurrencyUtils";
import { useFormContext } from "react-hook-form";

export const ModifyDepositFields = () => {
  const { t } = useResource();
  const { control, watch } = useFormContext();

  const regularAmount = watch("regularAmount");
  const currentAmount = watch("currentValue");
  const newRegularDeposit = watch("newRegularDeposit");
  const newDeposit = watch("newDeposit");

  return (
    <>
      <Grid size={6}>
        <FormNumberField
          control={control}
          name="newDeposit"
          label={t(Resources.AnalysisDetail.GoalsFulfillment.FormFields.NewDeposit)}
          required
          scale={2}
          thousandsSeparator=" "
          unit={t(Resources.Common.CZKSuffix)}
          fullWidth
        />

        {currentAmount && newDeposit && newDeposit - currentAmount !== 0 ? (
          <Box sx={{ width: "100%", textAlign: "right", mt: 1 }}>
            <Typography variant="caption" color="secondary">
              {t(Resources.AnalysisDetail.GoalsFulfillment.FormFields.NewDepositDifference)}:{" "}
              {formatCurrency(newDeposit - currentAmount, CurrencyCode.CZK, 2)}
            </Typography>
          </Box>
        ) : null}
      </Grid>

      <Grid size={6}>
        <FormNumberField
          control={control}
          name="newRegularDeposit"
          label={t(Resources.AnalysisDetail.GoalsFulfillment.FormFields.NewRegularDeposit)}
          required
          scale={2}
          min={0}
          thousandsSeparator=" "
          unit={`${t(Resources.Common.CZKSuffix)}/${t(Resources.Common.Month)}`}
          fullWidth
        />

        {regularAmount && newRegularDeposit && newRegularDeposit - regularAmount !== 0 ? (
          <Box sx={{ width: "100%", textAlign: "right", mt: 1 }}>
            <Typography variant="caption" color="secondary">
              {t(Resources.AnalysisDetail.GoalsFulfillment.FormFields.NewRegularDepositDifference)}:{" "}
              {formatCurrency(newRegularDeposit - regularAmount, CurrencyCode.CZK, 2)}
            </Typography>
          </Box>
        ) : null}
      </Grid>
    </>
  );
};
